import { Breadcrumb } from "@components/Breadcrumb/Breadcrumb";
import { Sections } from "@components/Sections/Sections";
import { BackgroundContainer } from "@components/Styled/Container";
import React from "react";
import tw from "twin.macro";
import RichText from "../RichText";
import { Images } from "./Images/Images";
import {
  Container,
  Content,
  Desktop,
  Mobile,
  Sticky,
  Title,
  TitleWrapper,
} from "./Shared";
import { withProduct } from "./withProduct";

const Description = tw(RichText)`
  block my-mini
`;
const SectionsWrapper = tw.div``;

export const Accessory = withProduct(
  ({
    badge,
    content,
    description,
    heroImage,
    images,
    paths,
    sectionsRef,
    subTitle,
    title,
    video,
  }) => (
    <>
      <BackgroundContainer background="light">
        <Desktop>
          <Breadcrumb paths={paths} float />
        </Desktop>
        <Container width="full">
          <Sticky>
            <Images
              image={heroImage}
              images={images}
              video={video}
              badge={badge}
            />
          </Sticky>
          <Content>
            <Mobile>
              <Breadcrumb paths={paths} float />
            </Mobile>
            <TitleWrapper>
              <Title>
                {title} {subTitle}
              </Title>
            </TitleWrapper>
            <Description html={description} />
          </Content>
        </Container>
      </BackgroundContainer>
      <SectionsWrapper ref={sectionsRef}>
        {content.content && <Sections page={content} />}
      </SectionsWrapper>
    </>
  ),
);

export default Accessory;
